export const ACCESSORY_POSITIONS = {
  CENTER: 'Center',
  TOP: 'Top',
  BOTTOM: 'Bottom',
} as const
